export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/7ZeLebPoLrZS9jXRExR9RG/METEO_IT_PAGINA_1.jpg',
    alt: "Copertina del Volume 1, Fondamenti di Meteorologia e Scienze dell'Atmosfera, con una stazione meteorologica sotto un cielo di nubi cumuliformi",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gVM1SNPsJZ8SxmuQqu67uC/METEO_IT_PAGINA_2.jpg',
    alt: "Pagina di esempio Il meteorologo traduce l'atmosfera in decisioni, sul ruolo del meteorologo: previsioni, allerte, analisi, supporto alle decisioni e comunicazione",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nK5Zt2oV4wfV7VvREEHcky/METEO_IT_PAGINA_3.jpg',
    alt: "Pagina di esempio Salendo, l'aria si fa più sottile: come cambiano pressione e densità con la quota",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mHL3qK8myKuC2FGMYbPpaG/METEO_IT_PAGINA_4.jpg',
    alt: "Pagina di esempio L'umidità relativa dipende dalla temperatura, con un errore comune degli studenti e l'approccio corretto",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7bXjZUEmnAuZJuFXNLtWuj/METEO_IT_PAGINA_5.jpg',
    alt: 'Pagina di esempio Osservare bene è il primo passo: la stazione meteorologica e i suoi strumenti',
  },
];
